import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import styles from "./Merchant.m.scss";

function MerchantHeader(props) {
  const { theme } = props;
  return (
    <div className={classnames(theme.header)}>
      <div>{"Id"}</div>
      <div>{"Наименование"}</div>
      <div>{"Адрес"}</div>
      <div>{"Город"}</div>
      <div>{"Индекс"}</div>
    </div>
  );
}

MerchantHeader.displayName = "MerchantHeader";

MerchantHeader.propTypes = {
  theme: PropTypes.object,
};

MerchantHeader.defaultProps = {};

export default themr("@lifepay/MerchantHeader", styles)(MerchantHeader);



// WEBPACK FOOTER //
// ./src/components/list-items/Merchant/Header.js